const insightsAIContent = {
  overview: {
    title: "inFlow InsightsAI",
    description:
      "inFlow InsightsAI connects your business databases and spreadsheets with natural language AI analytics, allowing teams to ask questions and generate real-time charts and reports instantly.",
    imageURL: "/images/products/InsightsAI-3D-Studio-Banner.png",
    screenURL: "/images/products/InsightsAI-3D-Studio-Banner.png",
    buttons: ["POS Insights", "InsightsAI Hospitality", "InsightsAI Excel"],
  },
  demos: [
    {
      title: "inFlow insights AI",
      path: "/demo/inflow-insights",
      image: "/images/products/InsightsAI-POS.png",
      description: [
        "Turn your data into instant insights. Analyze performance, identify trends, and compare key metrics — all using simple natural language queries.",
      ],
    },
    // {
    //   title: "Hospitality",
    //   path: "/demo/hospitality-insights",
    //   image: "/images/products/InsightsAI-Hospitality.png",
    //   description: [
    //     "Monitor occupancy, bookings, cancellations, and revenue trends with natural language prompts. Empower front office and operations teams to access real-time insights and visualisations.",
    //   ],
    // },
    {
      title: "InsightSheets AI",
      path: "/demo/insight-sheets",
      image: "/images/products/InsightsAI-Excel.png",
      description: [
        "Unlock the intelligence inside your spreadsheets. Identify trends, compare numbers, and create meaningful summaries — effortlessly.",
      ],
    },
  ],
  pricing: { text: "Updating soon" },
  usecase: [
    {
      industry: "Banking, Financial Services & Insurance (BFSI) ",
      points: [
        "Track loan performance, risk exposure, and delinquency trends through voice or text-based queries ",
        "Analyze customer segments by transaction behavior, region, or credit profile",
        "Generate real-time insights on claims, policy renewals, or fraud anomalies ",
        "Enable branch managers or sales teams to access data without BI licenses",
      ],
    },
    {
      industry: "Retail & E-commerce ",
      points: [
        "Monitor product-level sales, inventory movement, and promotion performance instantly",
        "Track conversion rates and cart abandonment across campaigns and geographies",
        "Identify top-performing SKUs, regional trends, and customer purchase patterns ",
        "Enable store managers to query data directly without corporate team dependencies",
      ],
    },
    {
      industry: "Logistics & Supply Chain",
      points: [
        "Surface data on delivery timelines, delays, and route efficiency via natural language",
        "Compare supplier performance, warehouse turnover, and order fulfillment rates",
        "Predict stockouts and demand surges based on historical trends ",
        "Help operations teams make real-time decisions across transport hubs",
      ],
    },
    {
      industry: "Human Resources & Workforce Analytics",
      points: [
        "Query attrition, headcount distribution, and performance metrics across departments",
        "Analyze hiring trends, diversity ratios, or training completion rates by business unit",
        "Enable leadership and HRBPs to access workforce insights on demand",
        "Support workforce planning with predictive analytics based on historical patterns ",
      ],
    },
    {
      industry: "Hospitality & Travel ",
      points: [
        "Understand occupancy rates, seasonal demand trends, and guest preferences instantly",
        "Track booking sources, revenue per available room (RevPAR), and cancellation reasons ",
        "Enable front office or operations teams to access guest satisfaction data without reports",
        "Compare performance across locations or service categories in real time",
      ],
    },
    {
      industry: "Manufacturing ",
      points: [
        "Give operations, plant, and quality teams instant visibility into performance without waiting on reports.",
        "Monitor machine utilization, downtime, and throughput across lines or shifts",
        "Compare output across factories, shifts, or supervisors with a single query ",
        "Analyze inventory levels, raw material usage, and replenishment cycles",
      ],
    },
  ],
  customerstory: {
    stories: [
      {
        text: "Coming soon",
        // url: "https://inextlabs.ai/resources/tealive-casestudy",
      },
    ],
  },
  resources: {
    diagrams: [
      {
        name: "InsightsAI Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/inflow-insights.svg",
        size: "SVG · 210 KB",
        desc: "High-resolution diagram of multi-source database aggregation and real-time visualization.",
        isHero: true,
      },
      {
        name: "Text-to-SQL Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/inFlow Data Intelligence.png",
        size: "PNG · 340 KB",
        desc: "Deep-dive technical topology of the Text-to-SQL transformation engine.",
      },
      {
        name: "InsightsAI Sample BOM",
        type: "doc",
        tag: "EXCEL",
        image: "documents/DocsAI-StandardExtraction-BOM.xlsx",
        size: "XLSX · 7.1 KB",
        desc: "Detailed bill of materials and integration requirements specification.",
      },
      {
        name: "InsightsAI proposal",
        type: "doc",
        tag: "DOC",
        image: "documents/inFlowInsightsAI-Proposal.docx",
        size: "DOCX · 6.2 MB",
        desc: "Enterprise proposal outlining data security, connectors, and SLA guarantees.",
      },
    ],
  },
};

export default insightsAIContent;
